import React from 'react';

import { useCopyContext } from '../../context/CopyContext';
import WrappedSupportersList from './ESSupportersList';

export function ESSupportersList() {
  const { supportersList } = useCopyContext();

  return (
    <WrappedSupportersList
      noSupportersMessage={supportersList.noSupportersMessage}
      displayDonateButton
    />
  );
}
